import { usePagination, DOTS } from 'hooks/usePagination'
import Icon from 'snippets/icon/icon'

function Pagination(props) {
  const { onPageChange, totalCount, siblingCount = 1, currentPage, pageSize } = props

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  })

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  const lastPage = paginationRange[paginationRange.length - 1]
  return (
    <ul className="mt-8 flex items-center justify-center lg:mt-12">
      {currentPage > 1 && (
        <li className="mx-1 flex h-8 w-8 cursor-pointer flex-col flex-wrap items-center justify-center" onClick={onPrevious}>
          <Icon viewBox="0 0 16 16" name="icon-chevron-left" className="h-6 w-6 text-grey-700" />
        </li>
      )}
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return <li className="dots mx-1 flex h-8 w-8 flex-col flex-wrap items-center justify-center rounded-full bg-grey-100">...</li>
        }

        return (
          <li
            className={`mx-1 flex h-8 w-8 flex-col flex-wrap items-center justify-center rounded-full bg-grey-100 text-grey-700 ${
              pageNumber === currentPage ? 'border border-primary' : 'cursor-pointer'
            }`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        )
      })}
      {currentPage !== lastPage && (
        <li className="mx-1 flex h-8 w-8 cursor-pointer flex-col flex-wrap items-center justify-center" onClick={onNext}>
          <Icon viewBox="0 0 16 16" name="icon-chevron-right" className="h-6 w-6 text-grey-700" />
        </li>
      )}
    </ul>
  )
}

export default Pagination
